import { request } from "../axios/request";
import * as queryParams from "qs";
import { createURL } from "../utils";
import $S from "theme/settings";
import {
  FETCH_CHECKOUT_PENDING,
  FETCH_CHECKOUT_MODAL_PENDING,
  FETCH_CHECKOUT_REJECTED,
  FETCH_CHECKOUT_FULFILLED,
  FETCH_CITIES_FULFILLED,
  FETCH_TOWNSHIPS_FULFILLED,
  FETCH_DISTRICTS_FULFILLED,
  SEND_ADDRESS_REJECTED,
  FETCH_CASH_REGISTER_REJECTED,
  SEND_QRCODE_EMAIL_FULFILLED,
  SEND_QRCODE_EMAIL_REJECTED,
  PAGES,
  SET_FALSE_THANK_YOU_PAGE,
  FETCH_GUEST_CHECKOUT_FULFILLED,
  FETCH_GUEST_CHECKOUT_PENDING,
  FETCH_GUEST_CHECKOUT_REJECTED,
  CLEAR_GUEST_CHECKOUT,
  CLEAR_CUSTOMER_CHECKOUT,
  CLEAR_CHECKOUT_REDIRECT,
  FETCH_COUNTRIES_FULFILLED,
} from "../constants/checkout";
import { objectSelector } from "theme/utils";

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
let sampleProductModal = ["Loccitane Instore"].includes($A.TITLE);

const pending = () => ({
  type: FETCH_CHECKOUT_PENDING,
});

const modalPending = () => ({
  type: FETCH_CHECKOUT_MODAL_PENDING,
});

const rejected = (error) => ({
  type: FETCH_CHECKOUT_REJECTED,
  error: error,
});

const sendAddressRejected = (error) => ({
  type: SEND_ADDRESS_REJECTED,
  error: error,
});

const fulfilled = (response) => ({
  type: FETCH_CHECKOUT_FULFILLED,
  response: response,
});

const guestCheckoutFulfilled = (response) => ({
  type: FETCH_GUEST_CHECKOUT_FULFILLED,
  response: response,
});

const guestCheckoutPending = () => ({
  type: FETCH_GUEST_CHECKOUT_PENDING,
});

const guestCheckoutRejected = (error) => ({
  type: FETCH_GUEST_CHECKOUT_REJECTED,
  error,
});

const countriesFulfilled = (response) => ({
  type: FETCH_COUNTRIES_FULFILLED,
  response: response,
});

const citiesFulfilled = (response) => ({
  type: FETCH_CITIES_FULFILLED,
  response: response,
});

const townshipsFulfilled = (response) => ({
  type: FETCH_TOWNSHIPS_FULFILLED,
  response: response,
});

const districtsFulfilled = (response) => ({
  type: FETCH_DISTRICTS_FULFILLED,
  response: response,
});

const cashRegisterRejected = (error) => ({
  type: FETCH_CASH_REGISTER_REJECTED,
  error: error,
});

const sendQrcodeEmailFulfilled = () => ({
  type: SEND_QRCODE_EMAIL_FULFILLED,
});

const sendQrcodeEmailRejected = () => ({
  type: SEND_QRCODE_EMAIL_REJECTED,
});

export const setFalseThankYouPage = () => ({
  type: SET_FALSE_THANK_YOU_PAGE,
});

export const clearGuestCheckout = () => ({
  type: CLEAR_GUEST_CHECKOUT,
});

export const clearCustomerCheckout = () => ({
  type: CLEAR_CUSTOMER_CHECKOUT,
});

export const clearRedirect = () => ({
  type: CLEAR_CHECKOUT_REDIRECT,
});

// const fetchSmsFulfilled = (response) => ({
//   type: FETCH_SMS_FULFILLED,
//   response,
// });

export const fetchCheckout = () => (dispatch) => {
  dispatch(pending());

  request({
    url: $U.CHECKOUT,
    method: "GET",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const fetchCountries = () => (dispatch) => {
  request({
    url: `${$U.ADDRESS_COUNTRY}?${queryParams.stringify({
      limit: 9999,
    })}`,
    method: "GET",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((response) => {
      dispatch(countriesFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const fetchCities = (country, name) => (dispatch) => {
  const isSearch = !!name;
  const limit = isSearch ? 10 : 9999;

  request({
    url: `${$U.ADDRESS_CITY}?${queryParams.stringify({
      country: country,
      limit,
      ...(isSearch && { name }),
    })}`,
    method: "GET",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((response) => {
      dispatch(citiesFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const fetchTownships = (city) => (dispatch) => {
  request({
    url: `${$U.ADDRESS_TOWNSHIP}?${queryParams.stringify({
      city: city,
      limit: 9999,
    })}`,
    method: "GET",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((response) => {
      dispatch(townshipsFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const fetchDistricts = (township) => (dispatch) => {
  request({
    url: `${$U.ADDRESS_DISTRICT}?${queryParams.stringify({
      township: township,
      limit: 9999,
    })}`,
    method: "GET",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((response) => {
      dispatch(districtsFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const sendAddressForm = (data, pk) => (dispatch) => {
  const url = pk ? createURL($U.ADDRESS, [pk]) : $U.ADDRESS;
  const method = pk ? "PATCH" : "POST";
  request({
    url,
    method,
    data,
  })
    .then((response) => {
      dispatch(setAddress(response.data.pk, response.data.pk, true));
    })
    .catch((error) => {
      dispatch(sendAddressRejected(error));
    });
};

export const deleteAddressForm = (pk) => (dispatch) => {
  const url = createURL($U.ADDRESS, [pk]);
  request({
    url,
    method: "DELETE",
  }).then((response) => {
    dispatch(setAddress(response.data.pk, response.data.pk, true));
  });
};

export const setGuestCheckout = (email, phone) => (dispatch) => {
  dispatch(guestCheckoutPending());

  request({
    url: `${$U.CHECKOUT}?page=${PAGES.indexPage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify({
      user_email: email,
      phone,
    }),
  })
    .then(({ data }) => dispatch(guestCheckoutFulfilled(data)))
    .catch((error) => dispatch(guestCheckoutRejected(error)));
};

export const setDeliveryOptionWithAddress =
  (address, billingAddress, deliveryOption) => (dispatch) => {
    dispatch(modalPending());

    request({
      url: `${$U.CHECKOUT}?page=${PAGES.deliveryOptionSelectionPage}`,
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      data: queryParams.stringify({
        delivery_option: deliveryOption,
      }),
    })
      .then((response) => {
        dispatch(fulfilled(response.data));
        dispatch(setAddress(address, billingAddress));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

export const setAddress =
  (address, billingAddress, refreshCheckout = false) =>
  (dispatch) => {
    dispatch(modalPending());

    request({
      url: `${$U.CHECKOUT}?page=${PAGES.addressSelectionPage}`,
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      data: queryParams.stringify({
        shipping_address: address,
        billing_address: billingAddress,
      }),
    })
      .then((response) => {
        dispatch(fulfilled(response.data));
        refreshCheckout && dispatch(fetchCheckout());
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

export const setDeliveryOption = (deliveryOption) => (dispatch) => {
  dispatch(modalPending());

  request({
    url: `${$U.CHECKOUT}?page=${PAGES.deliveryOptionSelectionPage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify({
      delivery_option: deliveryOption,
    }),
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const setRetailStore = (store, billingAddress) => (dispatch) => {
  dispatch(modalPending());

  request({
    url: `${$U.CHECKOUT}?page=${PAGES.retailStoreSelectionPage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify({
      retail_store: store,
      billing_address: billingAddress,
    }),
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const setShippingOption = (pk) => (dispatch) => {
  dispatch(modalPending());

  request({
    url: `${$U.CHECKOUT}?page=${PAGES.shippingOptionSelectionPage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify({
      shipping_option: pk,
    }),
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
      if (sampleProductModal) {
        let sampleProductData = response.data.context_list.filter(
          (item) => item.page_slug === "sampleproductpage"
        );
        let allowedQuantity =
          sampleProductData[0].page_context.allowed_quantity;
        localStorage.setItem(
          "localSampleProducts",
          JSON.stringify(sampleProductData[0].page_context.sample_products)
        );
        localStorage.setItem(
          "localSampleAllowedQuantity",
          JSON.stringify(allowedQuantity)
        );
      }
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const setSampleProduct = (queryString) => (dispatch) => {
  dispatch(modalPending());

  request({
    url: `${$U.CHECKOUT}?page=SampleProductPage`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryString,
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const setPaymentOption = (pk) => (dispatch) => {
  dispatch(modalPending());

  /**
   * TODO: If "paylater" doesn't work, set the url like this:
   * url: `${$U.PAY_LATER_POST}?page=${PAGES.paymentOptionSelectionPage}`
   */

  request({
    url: `${$U.CHECKOUT}?page=${PAGES.paymentOptionSelectionPage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify({
      payment_option: pk,
    }),
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
      /* Bancontact payment type */
      if (
        $A.BRAND === "TFS" &&
        objectSelector(response.data, `context_list.${[0]}.page_name`) ===
          PAGES.redirectionPaymentSelectedPage
      ) {
        dispatch(setPaymentRedirection(pk));
      }
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const setFundsTransferChoicePage = (pk) => (dispatch) => {
  dispatch(modalPending());

  request({
    url: `${$U.CHECKOUT}?page=${PAGES.fundsTransferChoicePage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify({ bank_account: pk }),
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const setPaymentFundTransfer =
  (agreement = false) =>
  (dispatch) => {
    dispatch(modalPending());

    request({
      url: `${$U.CHECKOUT}?page=${PAGES.fundsTransferPage}`,
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      data: queryParams.stringify({ agreement }),
    })
      .then((response) => {
        dispatch(fulfilled(response.data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

export const setPaymentRedirection =
  (pk, agreement = true) =>
  (dispatch) => {
    dispatch(modalPending());

    request({
      url: `${$U.CHECKOUT}?page=${PAGES.redirectionPaymentSelectedPage}`,
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      data: queryParams.stringify({
        payment_option: pk,
        agreement,
      }),
    })
      .then((response) => {
        dispatch(fulfilled(response.data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

export const onPayLaterButtonClick =
  (agreement = true) =>
  (dispatch) => {
    dispatch(modalPending());

    request({
      url: `${$U.CHECKOUT}?page=PayLaterCompletePage`,
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      data: queryParams.stringify({
        agreement,
      }),
    })
      .then((response) => {
        dispatch(fulfilled(response.data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

export const setInstallmentOption = (pk) => (dispatch) => {
  dispatch(modalPending());

  const params =
    Boolean(pk) && $S.hasInstallmentOptions
      ? { installment: pk }
      : { no_installment: true };

  request({
    url: `${$U.CHECKOUT}?page=${PAGES.cashRegisterInstallmentSelectionPage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify(params),
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const skipReservationSelectionPage = () => (dispatch) => {
  dispatch(modalPending());

  request({
    url: `${$U.CHECKOUT}?page=${PAGES.reservationSelectionPage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify({
      skip_reservation: true,
    }),
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const checkoutWithCashRegister = (agreement) => (dispatch) => {
  dispatch(modalPending());

  request({
    url: `${$U.CHECKOUT}?page=${PAGES.cashRegisterPage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify({
      agreement: agreement,
    }),
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(cashRegisterRejected(error));
    });
};

export const askToCash = () => (dispatch) => {
  request({
    url: `${$U.CHECKOUT}?page=${PAGES.cashRegisterCompletePage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: {},
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(cashRegisterRejected(error));
    });
};

export const sendSmsToCustomerPhone = (number) => (dispatch) => {
  request({
    url: `${$U.CHECKOUT}?page=${PAGES.sendBarcodeSmsPage}`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: {
      phone_number: number,
    },
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const addGiftBox = (checked) => (dispatch) => {
  request({
    url: `orders/checkout/?page=GiftBoxPage`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    data: queryParams.stringify({
      note: "",
    }),
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const removeGiftBox = (checked) => (dispatch) => {
  request({
    url: `orders/checkout/?page=GiftBoxIndexPage`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const sendQrCodeWithEmail = () => (dispatch) => {
  request({
    url: `orders/send-checkout-url-email/`,
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((response) => {
      dispatch(sendQrcodeEmailFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(sendQrcodeEmailRejected(error));
    });
};

export const setNotes =
  (notes = null) =>
  (dispatch) => {
    dispatch(modalPending());
    request({
      url: `${$U.CHECKOUT}?page=${PAGES.orderNotePage}`,
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      data: queryParams.stringify({ notes }),
    })
      .then((response) => {
        dispatch(fulfilled(response.data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };



// WEBPACK FOOTER //
// ./src/actions/checkout.js